<template>
  <div class="main-header">
    <div class="header">
      <h2>
        <i class="el-icon-s-unfold" v-if="menuData.collapse" @click="switchCollapseMenu(null)"></i>
        <i class="el-icon-s-fold" v-else @click="switchCollapseMenu(null)"></i>
        {{title}}
      </h2>
      <div class="user">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <!-- <span style="font-size:12px">余额¥ {{ JSON.parse(registeruser).monery }}</span>&nbsp;&nbsp; -->
            <img v-if="registeruser != null" :src="JSON.parse(registeruser).headimgurl == null ? '/static/avatar/man.png' : JSON.parse(registeruser).headimgurl" alt="">{{ JSON.parse(registeruser).nickname }}&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-size:12px">{{ JSON.parse(registeruser).lessonName }}</span>&nbsp;&nbsp;<span style="font-size:12px">{{ JSON.parse(registeruser).toolBox }}</span>&nbsp;&nbsp;<span style="font-size:12px">{{ JSON.parse(registeruser).userType }}</span>&nbsp;&nbsp;<b>{{ JSON.parse(registeruser).phone }}</b><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changeInfo">用户信息</el-dropdown-item>
            <el-dropdown-item @click.native="changePwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 修改密码 -->
    <GlobalWindow
      title="修改密码"
      :visible.sync="visible.changePwd"
      @confirm="confirmChangePwd"
      @close="visible.changePwd = false"
    >
      <el-form :model="changePwdData.form" ref="changePwdDataForm" :rules="changePwdData.rules">
        <el-form-item label="原始密码" prop="oldPwd">
          <el-input v-model="changePwdData.form.oldPwd" type="password" placeholder="请输入原始密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPwd">
          <el-input v-model="changePwdData.form.newPwd" type="password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPwd">
          <el-input v-model="changePwdData.form.confirmPwd" type="password" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
      </el-form>
    </GlobalWindow>
    <GlobalWindow
        title="修改用户信息"
        :visible.sync="visible.changeInfo"
        @confirm="confirmChangeInfo"
        @close="visible.changeInfo = false"
      >
      <el-form :model="changeInfoData.form" ref="changeInfoDataForm" :rules="changeInfoData.rules" :hide-required-asterisk="hide" label-position="left">
        <el-form-item label="省份:" prop="province">
          <el-select v-model="changeInfoData.form.province"  ref="province" @change="changeProvice">
            <el-option v-for="item in provinceList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市:" prop="city">
          <el-select v-model="changeInfoData.form.city"  ref="city">
            <el-option v-for="item in cityList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址:" prop="sendAddress">
          <el-input v-model="changeInfoData.form.sendAddress"  placeholder="请输入收货地址"></el-input>
        </el-form-item>
        <el-form-item label="机构名称:" prop="orgName">
          <el-input v-model="changeInfoData.form.orgName"  placeholder="请输入机构名称"></el-input>
        </el-form-item>
        <el-form-item label="医生姓名:" prop="doctorName" required>
          <el-input v-model="changeInfoData.form.doctorName"  placeholder="请输入医生姓名"></el-input>
        </el-form-item>
<!--        <el-form-item label="种植导板使用经验:" prop="lesson">
          <el-select v-model="changeInfoData.form.lesson" placeholder="种植导板使用经验">
            <el-option v-for="item in lessons" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>-->
<!--        <el-form-item label="手机号" prop="phone">
          <el-input v-model="changeInfoData.form.phone"  placeholder="请输入手机号"></el-input>
        </el-form-item>-->
<!--        <el-form-item label="电话" prop="tel">
          <el-input v-model="changeInfoData.form.tel"  placeholder="请输入电话"></el-input>
        </el-form-item>-->
        <el-form-item label="邮箱:" prop="email">
          <el-input v-model="changeInfoData.form.email"  placeholder="请输入邮箱"></el-input>
        </el-form-item>
<!--        <el-form-item label="导板工具盒:" prop="toolBox">
          <el-input v-model="changeInfoData.form.toolBox"  placeholder="请输入导板工具盒"></el-input>
        </el-form-item>-->
        <el-form-item>
          <label v-if="JSON.parse(registeruser).isCertified==0">待认证</label>
          <label v-if="JSON.parse(registeruser).isCertified==1">认证通过</label>
          <label v-if="JSON.parse(registeruser).isCertified==2">认证不通过</label>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="visibility=true">Realmaker CC用户认证</el-button>
        </el-form-item>
      </el-form>
    </GlobalWindow>
    <el-dialog
      width = "1200px"
      title="Realmaker CC认证"
      :close-on-click-modal="false"
      :visible.sync="visibility">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="序列号">
          <el-input v-model="form.sequences" placeholder="请输入Realmaker CC认证序列号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="visibility=false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../../store/index.js'
import { mapState, mapMutations } from 'vuex'
import GlobalWindow from './GlobalWindow'
export default {
  name: 'Header',
  components: { GlobalWindow },
  data () {
    return {
      form: {
        sequences: JSON.parse(localStorage.getItem('registeruser')).sequences
      },
      visibility: false,
      provinceList: null,
      cityList: null,
      hide: true,
      lessons: [{
        value: '0',
        label: '从未使用过种植导板'
      }, {
        value: '1',
        label: '使用过数量小于10个'
      }, {
        value: '2',
        label: '使用过数量超过10个'
      }],
      visible: {
        // 修改密码
        changePwd: false,
        changeInfo: false
      },
      isWorking: {
        // 修改密码
        changePwd: false,
        changeInfo: false
      },
      // 修改密码弹框
      changePwdData: {
        form: {
          oldPwd: '',
          newPwd: '',
          confirmPwd: '',
          registeruserId: ''
        },
        rules: {
          oldPwd: [
            { required: true, message: '旧密码不能为空' }
          ],
          newPwd: [
            { required: true, message: '请输入新密码' }
          ],
          confirmPwd: [
            { required: true, message: '请确认密码' }
          ]
        }
      },
      changeInfoData: {
        form: {
          // phone: JSON.parse(localStorage.getItem('registeruser')).phone,
          province: JSON.parse(localStorage.getItem('registeruser')).province,
          city: JSON.parse(localStorage.getItem('registeruser')).city,
          sendAddress: JSON.parse(localStorage.getItem('registeruser')).sendAddress,
          email: JSON.parse(localStorage.getItem('registeruser')).email,
          id: JSON.parse(localStorage.getItem('registeruser')).id,
          orgName: JSON.parse(localStorage.getItem('registeruser')).orgName,
          lesson: JSON.parse(localStorage.getItem('registeruser')).lesson,
          doctorName: JSON.parse(localStorage.getItem('registeruser')).doctorName,
          toolBox: JSON.parse(localStorage.getItem('registeruser')).toolBox,
          code: JSON.parse(localStorage.getItem('registeruser')).code,
          phone: JSON.parse(localStorage.getItem('registeruser')).phone
        },
        rules: {
          orgName: [{required: true, message: '组织单位不能为空'}],
          doctorName: [{required: true, message: '医生名称不能为空'}],
          sendAddress: [{required: true, message: '收货地址不能为空'}],
          email: [{required: true, message: '邮箱不能为空'},
            {
              message: '请输入正确的邮箱',
              trigger: 'blur',
              transform (value) {
                var emailreg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/ // /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
                if (!emailreg.test(value)) {
                  return false
                }
              }
            }
          ],
          lesson: [{required: true, message: '使用经验不能为空'}]
        }
      }
    }
  },
  computed: {
    ...mapState(['menuData', 'registeruser']), // store变量
    title () {
      return this.$route.meta.title
    }
  },
  /* filters: {
    // 展示名称
    displayName (registeruser) {
      if (registeruser == null) {
        return '11'
      }
      return registeruser.account
    }
  }, */
  methods: {
    ...mapMutations(['setRegisterUserInfo', 'switchCollapseMenu']), // store方法
    onSubmit () {
      axios.post('api/registeruser/updateSequences?id=' + JSON.parse(localStorage.getItem('registeruser')).id + '&sequences=' + this.form.sequences).then((res) => {
        this.visibility = false
        if (res && res.data.code === 200) {
          this.$message.success(res.data.result)
        } else {
          this.$message.error('提交失败')
        }
      })
    },
    // 修改密码
    changePwd () {
      this.visible.changePwd = true
      this.$nextTick(() => {
        this.$refs.changePwdDataForm.resetFields()
      })
    },
    changeInfo () {
      this.visible.changeInfo = true
      this.$nextTick(() => {
        this.$refs.changeInfoDataForm.resetFields()
      })
    },
    confirmChangeInfo () {
      if (this.isWorking.changeInfo) {
        return
      }
      this.$refs.changeInfoDataForm.validate((valid) => {
        if (!valid) {
          return
        }
        // 执行修改
        this.isWorking.changePwd = true
        // 修改密码
        axios.post('api/registeruser/update', this.changeInfoData.form).then((res) => {
          if (res && res.data.code === 200) {
            if (res.data.result == null) {
              this.$message.success('修改注册信息失败')
              return
            }
            setTimeout(() => {
              this.$message.success('修改注册信息成功')
              this.visible.changeInfo = false
              this.isWorking.changeInfo = false
            }, 1500)
            // store.commit('setRegisterUserInfo', res.data.result)
            store.registeruser = res.data.result
            localStorage.removeItem('registeruser')
            localStorage.setItem('registeruser', JSON.stringify(res.data.result))
            this.$router.go(0)
            /*JSON.parse(localStorage.getItem('registeruser')).tel = res.data.result.tel
            JSON.parse(localStorage.getItem('registeruser')).phone = res.data.result.phone
            JSON.parse(localStorage.getItem('registeruser')).email = res.data.result.email
            JSON.parse(localStorage.getItem('registeruser')).doctorName = res.data.result.doctorName
            JSON.parse(localStorage.getItem('registeruser')).orgName = res.data.result.orgName
            JSON.parse(localStorage.getItem('registeruser')).lesson = res.data.result.lesson*/
          } else {
            setTimeout(() => {
              this.$message.success('修改注册信息失败')
              this.visible.changePwd = false
              this.isWorking.changePwd = false
            }, 1500)
          }
        })
      })
    },
    // 确定修改密码
    confirmChangePwd () {
      if (this.isWorking.changePwd) {
        return
      }
      this.$refs.changePwdDataForm.validate((valid) => {
        if (!valid) {
          return
        }
        // 验证两次密码输入是否一致
        if (this.changePwdData.form.newPwd !== this.changePwdData.form.confirmPwd) {
          this.$message.warning('两次密码输入不一致')
          return
        }

        // 执行修改
        this.isWorking.changePwd = true
        this.changePwdData.form.registeruserId = JSON.parse(localStorage.getItem('registeruser')).id
        // 修改密码
        axios.post('api/registeruser/editPassword', this.changePwdData.form).then((res) => {
          if (res && res.data.code === 200) {
            setTimeout(() => {
              this.$message.success(res.data.result)
              this.visible.changePwd = false
              this.isWorking.changePwd = false
            }, 1500)
          } else {
            setTimeout(() => {
              this.$message.error(res.data.result)
              this.visible.changePwd = false
              this.isWorking.changePwd = false
            }, 1500)
          }
        })
      })
    },
    // 退出登录
    logout () {
      this.$router.push({name: 'login'})
      // this.setRegisterUserInfo(null)
      store.commit('logout')
    },
    // 选择省发生改变时
    changeProvice () {
      this.cityList = []
      var tmp = JSON.parse(localStorage.getItem('cityList'))
      for (var i = 0; i < tmp.length; i++) {
        if (tmp[i].provinceCode === this.changeInfoData.form.province) {
          this.cityList.push({
            'code': tmp[i].code,
            'name': tmp[i].name
          })
        }
      }
    }
  },
  created () {
    if (localStorage.getItem('provinceList') === null || localStorage.getItem('cityList') === null) {
      this.getProvinceAndCity()
    } else {
      this.provinceList = JSON.parse(localStorage.getItem('provinceList'))
      this.cityList = [] // JSON.parse(localStorage.getItem('cityList'))
      this.changeProvice()
    }
  },
  btnRealmic () {

  }
}
</script>

<style scoped lang="less">
@import "../../assets/style/variable";
.header {
  overflow: hidden;
  padding: 0 25px;
  background: #fff;
  height: 100%;
  display: flex;
  h2 {
    width: 50%;
    flex-shrink: 0;
    line-height: @header-height;
    font-size: 19px;
    font-weight: 600;
    color: #606263;
    display: inline;
    & > i {
      font-size: 20px;
      margin-right: 12px;
    }
  }
  .user {
    width: 50%;
    flex-shrink: 0;
    text-align: right;
    .el-dropdown {
      top: 2px;
    }
    img {
      width: 32px;
      position: relative;
      top: 10px;
      margin-right: 10px;
    }
  }
}
// 下拉菜单框
.el-dropdown-menu {
  width: 140px;
  .el-dropdown-menu__item:hover {
    background: #E3EDFB;
    color: @primary-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue